// Friend Request QR Code utilities
import { generateQRCode } from './qr-checkin';

/**
 * Generate friend request URL for QR code
 */
export const generateFriendRequestURL = (userId: string): string => {
  const baseURL = window.location.origin;
  return `${baseURL}/friend-request/${userId}`;
};

/**
 * Generate QR code data URL for friend request
 */
export const generateFriendRequestQR = async (userId: string): Promise<string> => {
  const url = generateFriendRequestURL(userId);
  return await generateQRCode(url);
};



